/**
 * Alt+1..9 — jump to one of the user's recently-visited routes.
 *
 * Reads the recent rail from the uiPrefsStore. Alt+1 is the most
 * recent, Alt+9 the ninth. Ignored while typing in inputs/textareas
 * and inside contentEditable surfaces.
 *
 * Mounted once from AppShell; no UI of its own.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUiPrefsStore } from '../../stores/uiPrefsStore';

export default function RecentJumpRuntime() {
  const navigate = useNavigate();
  const recents = useUiPrefsStore((s) => s.recentRoutes);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (!e.altKey) return;
      if (e.metaKey || e.ctrlKey) return;
      const tag = (e.target as HTMLElement | null)?.tagName?.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || (e.target as HTMLElement | null)?.isContentEditable) {
        return;
      }
      const i = parseInt(e.key, 10);
      if (!Number.isInteger(i) || i < 1 || i > 9) return;
      const target = recents[i - 1];
      if (!target) return;
      e.preventDefault();
      navigate(target);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [recents, navigate]);

  return null;
}
